<!--
  Сворачивание/разворачивание сайдбара: скруглённый квадрат панели с вертикальной
  линией-разделителем. Только контур — залитая колонка на мелком размере читается
  жирным пятном. Цвет один (prop fill), второго токена под обводку не нужно.
-->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" :stroke="fill" stroke-width="1.6" />
    <path d="M9.5 3.5v17" :stroke="fill" stroke-width="1.6" />
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: 'rgb(var(--text-primary))'
    }
  }
}
</script>
